import React, { useEffect, useState } from "react";

import { Box, Typography, Paper, CircularProgress } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { sendConfirmCodeToUCServer } from "./registerAPI";
import { ROUTES } from "./home/constants";

const titleContainer = document.getElementById("title")!;

export const FRegisterConfirm = () => {
  const { t, i18n } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState('');

  // 从URL参数或查询参数中获取邮箱地址
  const getEmailFromParams = () => {
    // 尝试从查询参数获取邮箱
    const emailFromQuery = searchParams.get('email');
    if (emailFromQuery) {
      return decodeURIComponent(emailFromQuery);
    }
    
    // 尝试从location.state获取邮箱
    if (location.state && location.state.email) {
      return location.state.email;
    }
    
    return '';
  };

  const triggerSyncTasks = async () => {
    const { id, code } = params;
    
    if (!id || !code) {
      navigate(ROUTES.registerError);
      return;
    }

    try {
      const response = await sendConfirmCodeToUCServer(id, code);
      if (response.code === 0) {
        // 注册确认成功，显示成功信息
        setIsLoading(false);
        setEmail(getEmailFromParams());
      } else {
        navigate(`${ROUTES.registerError}?code=${response.code}`);
      }
    } catch (error) {
      console.error('确认码发送失败:', error);
      navigate(ROUTES.registerError);
    }
  };

  useEffect(() => {
    // 设置页面标题
    titleContainer.innerHTML = t("webTitle");
    
    // 触发确认码发送
    triggerSyncTasks();
  }, []);

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)',
      padding: 2
    }}>
      <Paper elevation={8} sx={{ 
        maxWidth: 500, 
        width: '100%', 
        padding: 4,
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.95)'
      }}>
        {isLoading ? (
          <Box>
            <CircularProgress size={60} thickness={4} sx={{ mb: 3, color: '#26d0ce' }} />
            <Typography variant="h6" color="text.primary" gutterBottom>
              {t('register.confirmProcessing')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('register.confirmProcessingDescription')}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography variant="h4" color="primary.main" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
              {t('register.registrationSuccess')}
            </Typography>
            
            <Box sx={{ 
              p: 3, 
              mb: 3, 
              borderRadius: 2,
              background: 'linear-gradient(135deg, #f5f7ff 0%, #e3f2fd 100%)',
              border: '1px solid #e0e0e0'
            }}>
              <Typography variant="h6" color="success.main" gutterBottom sx={{ fontWeight: 'bold' }}>
                {t('register.confirmTitle')}
              </Typography>
              <Typography variant="body1" color="text.primary" sx={{ lineHeight: 1.6, mb: 2 }}>
                {t('register.confirmDescription')}
              </Typography>
              {email && (
                <Typography variant="body1" color="primary.main" sx={{ 
                  fontWeight: 'bold', 
                  fontSize: '1.1rem',
                  backgroundColor: 'rgba(38, 208, 206, 0.1)',
                  padding: 1,
                  borderRadius: 1,
                  border: '1px solid rgba(38, 208, 206, 0.3)'
                }}>
                  {email}
                </Typography>
              )}
            </Box>
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.5 }}>
              {t('register.confirmInstructions')}
            </Typography>
            
            <Box sx={{ 
              p: 2, 
              backgroundColor: '#f8f9fa', 
              borderRadius: 1,
              border: '1px dashed #dee2e6'
            }}>
              <Typography variant="caption" color="text.secondary">
                {t('register.confirmNote')}
              </Typography>
            </Box>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default FRegisterConfirm;
